import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1.25rem;
  font-size: 1rem;
`;

export const ItemContainer = styled.div`
  display: flex;
  column-gap: 1rem;

  & .item-column {
    flex-wrap: wrap;
    word-wrap: break-word;
    justify-content: center;
    flex-grow: 1;

    &__subtitle {
      color: ${({ theme }) => theme.colors.grayDark};
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #414e55;
    }

    &__content {
      max-width: 12rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #414e55;
    }
  }

  & .item-column:first-child {
    max-width: 12rem;
  }
`;

export const SimpleGraphContainer = styled.div`
  width: 13.0625rem;
`;

export const HorizontalSeparator = styled.div`
  height: 1px;
  background: #d2d3d4;
`;
